var READING = "reading";
var WRITING = "writing";
var OG_READING = "og-reading";

var Skillsets = {
	TYPES: {
		"ri1-key-details": {
			name: "RI1 - Key Ideas & Details - Details",
			type: READING,
			icon_env: "underwater",
			env: "details",
			non_fiction_only: true
		},
		"ri2-key-main": {
			name: "RI2 - Key Ideas & Details - Main Ideas",
			type: READING,
			icon_env: "lake",
			env: "details",
			non_fiction_only: true
		},
		"ri5-craft-structure": {
			name: "RI5 - Craft & Structure - Structure",
			type: READING,
			icon_env: "sky",
			env: "text-structure",
			non_fiction_only: true
		},
		"ri6-craft-pov": {
			name: "RI6 - Craft & Structure - Points of View",
			type: READING,
			icon_env: "tundra",
			env: "purpose-and-points-of-view",
			non_fiction_only: true
		},
		"ri7-integration-media": {
			name: "RI7 - Integration of Knowledge & Ideas - Media Portrayals",
			type: READING,
			icon_env: "farm",
			env: "media-and-formats",
			non_fiction_only: true
		},
		"ri8-integration-linear": {
			name: "RI8 - Integration of Knowledge & Ideas - Linear Reasoning",
			type: READING,
			icon_env: "beach",
			env: "arguments-and-evidence",
			non_fiction_only: true
		},

		"rl1-key-details": {
			name: "RL1 - Key Ideas & Details - Details",
			type: READING,
			icon_env: "space",
			env: "details",
			fiction_only: true
		},
		"rl2-key-main": {
			name: "RL2 - Key Ideas & Details - Main Ideas",
			type: READING,
			icon_env: "city",
			env: "details",
			fiction_only: true
		},
		"rl3-key-connections": {
			name: "RL3 - Key Ideas & Details - Connections",
			type: READING,
			icon_env: "savannah",
			env: "details",
			fiction_only: true
		},
		"rl5-craft-structure": {
			name: "RL5 - Craft & Structure - Structure",
			type: READING,
			icon_env: "jungle",
			env: "text-structure",
			fiction_only: true
		},
		"rl6-craft-pov": {
			name: "RL6 - Craft & Structure - Points of View",
			type: READING,
			icon_env: "mushrooms",
			env: "purpose-and-points-of-view",
			fiction_only: true
		},
		"rl7-integration-media": {
			name: "RL7 - Integration of Knowledge & Ideas - Media Portrayals",
			type: READING,
			icon_env: "desert",
			env: "media-and-formats",
			fiction_only: true
		},

		"pov": {
			name: "Purpose & Point of View",
			type: OG_READING,
			icon_env: "underwater",
			env: "purpose-and-points-of-view",
		},
		"developments": {
			name: "Developments & Interactions",
			type: OG_READING,
			icon_env: "sky",
			env: "developments-and-interactions",
		},
		"inferences": {
			name: "Inferences",
			type: OG_READING,
			icon_env: "tundra",
			env: "inferences",
		},
		"ideas": {
			name: "Key Ideas",
			type: OG_READING,
			icon_env: "lake",
			env: "key-ideas",
		},
		"vocabulary": {
			name: "Vocabulary",
			type: OG_READING,
			icon_env: "farm",
			env: "vocabulary",
		},
		"structure": {
			name: "Text Structure",
			type: OG_READING,
			icon_env: "beach",
			env: "text-structure",
		},
		"media": {
			name: "Medias & Formats",
			type: OG_READING,
			icon_env: "space",
			env: "media-and-formats",
		},
		"arguments": {
			name: "Arguments & Evidence",
			type: OG_READING,
			icon_env: "city",
			env: "arguments-and-evidence",
			stems: ["nfarg"]
		},
		"connections": {
			name: "Text to Text Connections",
			type: OG_READING,
			icon_env: "savannah",
			env: "connections",
		},


		"caps": {
			name: "Capitalization",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"evidence": {
			name: "Citing Evidence",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"org": {
			name: "Organization",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"spelling": {
			name: "Spelling",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"word": {
			name: "Word Use",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"conventions": {
			name: "Writing Conventions",
			type: WRITING,
			icon_env: "forest",
			env: "forest"
		},
		"skillset-narrative": {
			name: "Narrative Essay",
			type: WRITING,
			icon_env: "forest",
			env: "narrative"
		},
		"skillset-persuasive": {
			name: "Persuasive Essay",
			type: WRITING,
			icon_env: "savannah",
			env: "persuasive"
		},
		"skillset-informational": {
			name: "Informational Essay",
			type: WRITING,
			icon_env: "city",
			env: "informational"
		},
	},

	// It's not really a skill set but it's sometimes treated like one:
	REVIEW: {
		name: "Book Review",
		standard: "None",
		description: "Write a book review about what you've written to share your knowledge with people who might not have read the text.",
		env: "reviews",
		paid: false
	},

	getData(skillsetKey) {
		if (skillsetKey == "review") {
			return Skillsets.REVIEW;
		} else {
			return Skillsets.TYPES[skillsetKey];
		}
	},

	getName: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.name; }
	},

	getShortName: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return _.last(skillset.name.split(" - ")); }
	},

	getStandard: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.standard; }
	},

	getDescription: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.description; }
	},

	getIcon: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) {
			return dynamicRequire("skillset-icons/icon-" + skillset.icon_env + ".png");
		}		
	},

	getBanner: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if ($wr.isDevelopment()) {
			var imgBase = "http://localhost:3003";
		} else if ($wr.isProduction()) {
			var imgBase = "https://app.whooosreading.org/albus_assets";
		} else if ($wr.isStaging()){
			var imgBase = "https://app.savvashortondev.com/albus_assets";
		}

		if (skillset) {
			return imgBase + "/skillset_banners/banner-" + skillset.env + ".png";
		}
	},

	getStems: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);		
		if (skillset) {return skillset.stems}
	},

	isPaid: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.paid; }
	},

	hasFiction: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return !skillset.non_fiction_only; }
	},

	hasNonFiction: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return !skillset.fiction_only; }
	},

	isReading: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == READING; }
	},

	isOgReading: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == OG_READING; }
	},

	isWriting: function(skillsetKey) {
		var skillset = Skillsets.getData(skillsetKey);
		if (skillset) { return skillset.type == WRITING; }
	}

}

Skillsets.SKILLSET_KEYS = _.keys(Skillsets.TYPES);
Skillsets.READING_SKILLSET_KEYS = _.select(Skillsets.SKILLSET_KEYS, Skillsets.isReading);

module.exports = Skillsets;



// WEBPACK FOOTER //
// ./modules/lib/academic/Skillsets.js